
export const payrollCutoffDate = 15;